<!--
 * @Author: your name
 * @Date: 2020-11-08 22:39:33
 * @LastEditTime: 2026-07-10 16:57:20
 * @LastEditors: hl
 * @Description: In User Settings Edit
 * @FilePath: /mall-wap-vue/src/views/order/orderpay/index.vue
 -->
<template>
  <div>
    <title-bar-back
      v-if="
        this.$route.query.whereFrom !== 'app' &&
          this.$route.query.whereFrom !== 'miniApp'
      "
      :title="$G('收银台')"
      @back="back"
    >
      <div class="title_right"></div>
    </title-bar-back>
    <div class="pay_con" :style="{ top: isShowTitleBar ? '48px' : '0' }">
      <!-- 头部：金额与订单号 -->
      <div class="pay_header">
        <div class="pay_amount text_center">
          {{ getUserOrder.total | currency(false) }}
        </div>
        <div class="pay_order_sn font12 font_weight400 colo055 text_center">
          订单号：{{ getUserOrder.orderSn || $route.query.orderSn }}
        </div>
      </div>

      <!-- 支付剩余时间倒计时条 -->
      <div
        v-if="getUserOrder.remainingTime"
        class="pay_countdown_bar text_center font12"
      >
        <van-count-down
          :time="getUserOrder.remainingTime"
          class="countdown_text"
          format="支付剩余时间 HH:mm:ss"
          @finish="onCountdownFinish"
        />
      </div>

      <!-- 支付方式内容区分流 -->
      <div v-if="getUserOrder.orderSn" class="pay_methods_con">
        <!-- 分支一：appSource为3且payType为1，提供 Stripe 线上支付 -->
        <template v-if="$appSource === 3 && payType === 1">
          <stripe-pay :user-order="getUserOrder" />
        </template>

        <!-- 分支二：appSource为3且payType为2，提供 线下转账支付及上传凭证 -->
        <template v-else-if="$appSource === 3 && payType === 2">
          <offline-pay :user-order="getUserOrder" />
        </template>

        <!-- 分支三：appSource不为3，提供原微信支付 -->
        <template v-else>
          <wechat-pay :user-order="getUserOrder" />
        </template>
      </div>
    </div>
  </div>
</template>

<script>
const wx = require("jweixin-module");

const TitleBarBack = () =>
  import("@/components/TitleBarBack").then(m => m.default || m);
const StripePay = () => import("./components/StripePay");
const OfflinePay = () => import("./components/OfflinePay");
const WechatPay = () => import("./components/WechatPay");

export default {
  name: "OrderPay",
  components: {
    TitleBarBack,
    StripePay,
    OfflinePay,
    WechatPay
  },
  computed: {
    getUserOrder() {
      return this.$store.getters.getUserOrder;
    },
    payType() {
      // 优先取接口返回的支付方式，若未定义则默认 1 (线上支付)
      return this.getUserOrder.payType !== undefined
        ? this.getUserOrder.payType
        : 1;
    },
    // 判断是否展示标题栏
    isShowTitleBar() {
      return (
        this.$route.query.whereFrom !== "app" &&
        this.$route.query.whereFrom !== "miniApp"
      );
    }
  },
  created() {
    this.getData();
    // whereFrom 为 app 或者 miniApp 时修改浏览器的标题为“收银台”
    const whereFrom = this.$route.query.whereFrom;
    if (whereFrom === "app" || whereFrom === "miniApp") {
      document.title = "收银台";
    }
  },
  methods: {
    /**
     * 判断是否处于微信小程序 WebView 环境
     */
    isMiniProgram() {
      // 1. 检查路由参数 whereFrom 是否为 miniApp（首要判定）
      if (this.$route.query.whereFrom === "miniApp") {
        return true;
      }
      // 2. 检查小程序特有的 User Agent 兼容
      const ua = navigator.userAgent.toLowerCase();
      if (ua.indexOf("miniprogram") > -1) {
        return true;
      }
      // 3. 检查微信 JS-SDK 写入的环境变量兼容
      if (window.__wxjs_environment === "miniprogram") {
        return true;
      }
      return false;
    },

    // 获取数据
    getData() {
      const params = {
        orderSn: this.$route.query.orderSn
      };
      const isFromValet = this.$route.query.fromValet == 1;

      if (isFromValet) {
        this.$store
          .dispatch("order/loadFastOrderDetail", { params })
          .then(() => {
            this.$store.commit(
              "order/SET_GETUSERORDER",
              this.$store.state.order.fast
            );
            if (this.$appSource === 3 && this.payType === 2) {
              this.$store
                .dispatch("order/getCorporatePaymentInformation")
                .catch(() => {});
            }
          })
          .catch(() => {});
      } else {
        this.$store
          .dispatch("order/getUserOrder", { params })
          .then(() => {
            if (this.$appSource === 3 && this.payType === 2) {
              this.$store
                .dispatch("order/getCorporatePaymentInformation")
                .catch(() => {});
            }
          })
          .catch(() => {});
      }
    },
    back() {
      // 微信小程序 WebView 页面返回逻辑兼容
      if (this.isMiniProgram()) {
        const backPath = this.$route.query.miniBackPath;
        if (backPath) {
          wx.miniProgram.redirectTo({
            url: backPath
          });
        } else {
          wx.miniProgram.navigateBack();
        }
        return;
      }

      const stack = this.$routerStack || [];
      const prevPath = stack.length >= 2 ? stack[stack.length - 2] : "";

      if (prevPath === "/order/list" || prevPath === "/order/detail") {
        this.$router.back();
        return;
      }

      const orderListIndex = stack.findIndex(path => path === "/order/list");
      const productDetailIndex = stack.findIndex(
        path => path === "/product/detail"
      );
      const qqgPayIndex = stack.findIndex(
        path => path === "/user/order/fast/qqgpay"
      );

      if (orderListIndex !== -1) {
        const delta = orderListIndex - (stack.length - 1);
        this.$router.go(delta);
      } else if (productDetailIndex !== -1) {
        const delta = productDetailIndex - (stack.length - 1);
        this.$router.go(delta);
      } else if (qqgPayIndex !== -1) {
        // const delta = qqgPayIndex - (stack.length - 1);
        this.$router.back();
      } else {
        this.$router.push({
          path: "/"
        });
      }
    },
    // 倒计时结束，自动替换跳转到订单详情，不可返回收银台
    onCountdownFinish() {
      // 小程序环境下倒计时结束发送消息通知，并直接跳转到小程序订单详情页
      if (this.isMiniProgram()) {
        const orderSn = this.getUserOrder.orderSn || this.$route.query.orderSn;
        wx.miniProgram.postMessage({
          data: {
            action: "StripePayResult",
            status: "timeout",
            orderSn: orderSn
          }
        });

        const failUrl = `/pages/ordercenter/orderdetail/orderdetail?orderSn=${orderSn}`;
        setTimeout(() => {
          wx.miniProgram.redirectTo({
            url: failUrl
          });
        }, 1000);
        return;
      }

      this.$router.replace({
        path: "/order/detail",
        query: {
          orderSn: this.getUserOrder.orderSn || this.$route.query.orderSn
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.title_right {
  width: 36px;
}
.pay_con {
  background: #fff;
  position: absolute;
  top: 48px;
  left: 0;
  right: 0;
  bottom: 0;
  overflow-y: auto;
  /* 预留出悬浮底栏 + 刘海全面屏安全区高度 */
  padding-bottom: calc(85px + constant(safe-area-inset-bottom));
  padding-bottom: calc(85px + env(safe-area-inset-bottom));
  box-sizing: border-box;

  /* 头部新改版样式 */
  .pay_header {
    background: #fff;
    padding: 36px 0 18px;
    .pay_amount {
      font-size: 34px;
      font-weight: 700;
      color: #000;
      line-height: 42px;
      font-family: "Outfit", -apple-system, sans-serif;
    }
    .pay_order_sn {
      margin-top: 10px;
      font-size: 11px;
      color: #666;
      line-height: 15px;
    }
  }

  /* 倒计时横条 */
  .pay_countdown_bar {
    background: #fff8f0;
    padding: 10px 0;
    display: flex;
    justify-content: center;
    align-items: center;
    .countdown_text {
      color: #ff9933;
      font-weight: 500;
      font-size: 12px;
    }
  }

  .pay_methods_con {
    padding-top: 10px;
  }
}
</style>
